import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/app.reducer';
import { SearchProps } from 'app/interfaces';
import { CategoryResponse, Search } from 'app/models';

const IGNORE_LABEL_NAME = 'Ignore';

@Injectable({
  providedIn: 'root',
})
export class SearchFilterDefaultsService {
  private categories: CategoryResponse[] = [];
  private pendingSearches: Array<{
    search: Search;
    authorLabels: boolean;
    outletLabels: boolean;
  }> = [];

  constructor(store: Store<AppState>) {
    store.select('category').subscribe(({ categories }) => {
      this.categories = categories || [];
      this.applyLoadedDefaults();
    });
  }

  public createSearch(search: SearchProps = {}): Search {
    const ignoreLabelIds = this.getIgnoreLabelIds();

    const defaultAuthorLabels = search.excludeAuthorLabels === undefined;
    const defaultOutletLabels = search.excludeOutletLabels === undefined;
    const result = new Search({
      ...search,
      excludeAuthorLabels: defaultAuthorLabels
        ? ignoreLabelIds
        : search.excludeAuthorLabels,
      excludeOutletLabels: defaultOutletLabels
        ? ignoreLabelIds
        : search.excludeOutletLabels,
    });

    if (!ignoreLabelIds.length && (defaultAuthorLabels || defaultOutletLabels)) {
      this.pendingSearches.push({
        search: result,
        authorLabels: defaultAuthorLabels,
        outletLabels: defaultOutletLabels,
      });
    }
    return result;
  }

  public getIgnoreLabelIds(): number[] {
    return this.categories
      .filter((category) => category.name === IGNORE_LABEL_NAME)
      .map((category) => category.id);
  }

  private applyLoadedDefaults() {
    const ignoreLabelIds = this.getIgnoreLabelIds();
    if (!ignoreLabelIds.length) { return; }

    this.pendingSearches.forEach(({ search, authorLabels, outletLabels }) => {
      if (authorLabels) {
        search.excludeAuthorLabels = [...ignoreLabelIds];
      }
      if (outletLabels) {
        search.excludeOutletLabels = [...ignoreLabelIds];
      }
    });
    this.pendingSearches = [];
  }
}
